import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Minus, Plus } from "lucide-react";

export const FAQS = [
  {
    q: "Which areas do you serve?",
    a: "We are based at New Bypass Road, New Zero Mile, Patna, and we move homes, offices and cars from Patna to anywhere in India — and back.",
  },
  {
    q: "How do I get a moving quote?",
    a: "Fill in the free estimate form on this page, call us on 9135667888 or 9135668888, or tap the WhatsApp button. Our moving specialist will call you back with a clear, tailored estimate.",
  },
  {
    q: "What does a move cost?",
    a: "Every move is different — the price depends on your goods volume, the distance and the services you choose. We survey your move and give you one transparent quote with zero hidden charges.",
  },
  {
    q: "Is my luggage safe and insured?",
    a: "Your goods are packed with premium material by trained crews, and transit insurance is available on request for extra peace of mind.",
  },
  {
    q: "Do you transport cars and bikes?",
    a: "Yes. We run enclosed and open car carriers with doorstep pickup and delivery, GPS-tracked journeys, and careful loading so your vehicle arrives without a scratch.",
  },
  {
    q: "Do you offer storage?",
    a: "Yes. Our Patna warehouse is CCTV-monitored, pest-controlled and weather-safe, with flexible short or long term plans and a full inventory taken at check-in.",
  },
];

export const FAQ = () => {
  const [open, setOpen] = useState(0);

  return (
    <section className="section faq-section" id="faq">
      <div className="container faq-grid">
        <div className="faq-intro">
          <p className="overline">Good to know</p>
          <h2>Questions, <em>answered.</em></h2>
          <p className="section-sub">The things people ask us most before a move. For anything else, call or WhatsApp — a human always answers.</p>
        </div>
        <div className="faq-list" data-testid="faq-list">
          {FAQS.map((item, i) => (
            <div className={`faq-item ${open === i ? "open" : ""}`} key={item.q}>
              <button
                className="faq-question"
                data-testid={`faq-question-${i + 1}`}
                onClick={() => setOpen(open === i ? -1 : i)}
                aria-expanded={open === i}
              >
                <span>{item.q}</span>
                {open === i ? <Minus size={17} /> : <Plus size={17} />}
              </button>
              <AnimatePresence initial={false}>
                {open === i && (
                  <motion.div
                    className="faq-answer-wrap"
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
                  >
                    <p className="faq-answer" data-testid={`faq-answer-${i + 1}`}>{item.a}</p>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
